<template>
  <div class="px-4 ml-6 pt-4 layout-row layout-wrap" :style="{'background': compColor.lxExpansion.background}">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <!-- Grunddaten -->

    <div class="flex-100 px-3 py-1 my-6 mx-2"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.BASE_PROGRESS_SUB_LINE') }}</span>
    </div>

    <!-- Typ -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.tumorConference.typ'"
                           :ref="path + '.additionalFields.tumorConference.typ'"
                           rules="required"
                           v-slot="{ errors }">

        <!-- Typ as hidden field to define the correct associated value to validator -->

        <v-text-field
            v-model="model.additionalFields.tumorConference.typ"
            v-show="false"
            :dense="denseFields"
            outlined
            hide-details
            :error-messages="errors[0]"
        ></v-text-field>

        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TYPE') + ' *'"
          v-model="tumorConferenceTypesListItem"
          :items="tumorConferenceTypes"
          outlined
          @change="setReportReason(tumorConferenceTypesListItem)"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Datumsgenauigkeit Tumorkonferenz datum -->

    <div class="flex-gt-sm-50 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex"
                           :name="path + '.additionalFields.tumorConference.datum_genauigkeit'"
                           :ref="path + '.additionalFields.tumorConference.datum_genauigkeit'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_DATE_ACCURACY') + ' *'"
          v-model="model.additionalFields.tumorConference.datum_genauigkeit"
          :items="DateAccuracyTypes"
          outlined
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
               style="cursor: pointer;">
            <v-icon :color="compColor.prime" medium>info</v-icon>
          </div>
        </template>
        <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
      </v-tooltip>
    </div>

    <!-- Therapieempfehlung -->

    <div class="flex-100 px-2 mb-4">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_RECOMMENDATION')">

        <div class="layout-column flex pa-2" v-if="model.additionalFields.tumorConference.therapieempfehlung">

          <!-- Abweichung_Patientenwunsch -->

          <div class="layout-row px-2 pb-2 mb-1 flex layout-align-start-center">
            <label class="mr-8"
                   :style="{'color': compColor.isInDarkMode ? '#ffffff' : '#616161', 'font-size': denseFields ? '0.9em' : '16px'}">
              {{ $t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_LABEL_DEVIATION_PATIENT_WISH') }} *
            </label>

            <validation-provider tag="div"
                                 :name="path + '.additionalFields.tumorConference.therapieempfehlung.abweichung_patientenwunsch'"
                                 :ref="path + '.dru'"
                                 rules="required"
                                 class="layout-column"
                                 v-slot="{ errors }">
              <v-radio-group :dense="denseFields" v-model="model.additionalFields.tumorConference.therapieempfehlung.abweichung_patientenwunsch"
                             row hide-details
                             :error-messages="errors[0]"
                             class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES')"
                         class="ml-3"
                         value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                         value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                         value="U" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
              </v-radio-group>

              <div v-if="errors[0]" class="layout-row layout-align-center-center">
                <span style="color: rgb(255,82,82);font-size: 12px;">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </div>

          <!-- Therapieempfehlung Typ -->

          <div v-bind:style="{'z-index': '4'}" class="layout-row flex layout-align-start-center pa-1">
            <lx-btn icon="add_circle"
                    :color="compColor.primeColor"
                    :iconColor="'white'"
                    :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_ADD_RECOMMENDATION')"
                    :tooltip="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_ADD_RECOMMENDATION')"
                    iconSize="21"
                    :width="'auto'"
                    :height="35"
                    @click="addNewRecommendation()"
            ></lx-btn>
          </div>

          <div :key="index" v-for="(item, index) in model.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen"
               class="layout-row pa-0 ma-1"
               :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
               style="border-radius:4px;"
               :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

            <div class="layout-row layout-wrap flex px-4 pt-4">
              <div class="flex flex-100 px-2">
                <validation-provider tag="div"
                                     :name="path + '.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen.' + index"
                                     :ref="path + '.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen.' + index"
                                     rules="required"
                                     v-slot="{ errors }">
                  <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TYPE_RECOMMENDATION') + ' *'"
                    v-model="model.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen[index]"
                    :items="Tumorkonferenz_EmpfehlungTypes"
                    outlined
                    hide-details
                    :dense="denseFields"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on"
                                   :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                        <v-list-item-content class="py-0">
                          <label style="cursor:pointer;"
                                 :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                 class="lighten-4 text--darken-2">{{ item.text }}</label>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </div>
            </div>

            <div class="layout-column layout-align-center-center px-3"
                 :class="{'grey lighten-2': !compColor.isInDarkMode}"
                 :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
              <lx-btn @click="deleteRecommendation(model.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen, index, path + '.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen.' + index)"
                      :color="compColor.primeColor"
                      :disabled="model.additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen.length === 1"
                      :iconColor="'white'"
                      iconSize="21"
                      :width="35"
                      :height="35"
                      icon="delete_forever">
              </lx-btn>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!--  ANMERKUNG  -->

    <div class="flex-gt-sm-100 flex-100">
      <div class="flex-100 px-3 py-1 mt-2 mx-2 mb-5"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TEXT') }}</span>
      </div>

      <anmerkung :path="path + '.additionalFields.tumorConference.anmerkung'"
                 :isDisabled="isFormDisabled()"
                 v-model="model.additionalFields.tumorConference.anmerkung"
                 class="layout-row layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
    </div>
  </div>
</template>

<script>
import metaData from '../../../components/documentation/shared/formsMetaData'
import utils from '../../../common/utils'

import Anmerkung from '../../../components/documentation/shared/Anmerkung'
import Melder from '../../../components/documentation/shared/Melder'

export default {
  name: 'TumorConference',
  mixins: [metaData, utils],
  components: {
    Melder,
    Anmerkung
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        additionalFields: {
          tumorConference: {}
        }
      })
    },
    path: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      model: {
        additionalFields: {
          tumorConference: {}
        }
      },
      tumorConferenceTypes: [],
      tumorConferenceTypesListItem: null,
      DateAccuracyTypes: null,
      Tumorkonferenz_EmpfehlungTypes: null
    }
  },
  created () {
    this.tumorConferenceTypes = this.formsMetaData.Tumorkonferenz_TypTypes_Long
    this.Tumorkonferenz_EmpfehlungTypes = this.formsMetaData.Tumorkonferenz_EmpfehlungTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyLong
  },
  methods: {
    /**
     * Set report reason after changing tumor conference type
     *
     * @param type The tumor conference type
     */
    setReportReason (type) {
      switch (type) {
        case 'praethDiagnosis':
          this.model.reportType = 'diagnose'
          this.model.additionalFields.tumorConference.typ = 'praeth'
          break
        case 'praethTreatment':
          this.model.reportType = 'behandlungsbeginn'
          this.model.additionalFields.tumorConference.typ = 'praeth'
          break
        case 'praethState':
          this.model.reportType = 'statusaenderung'
          this.model.additionalFields.tumorConference.typ = 'praeth'
          break
        case 'postop':
          this.model.reportType = 'behandlungsende'
          this.model.additionalFields.tumorConference.typ = 'postop'
          break
        case 'therDiagnosis':
          this.model.reportType = 'diagnose'
          this.model.additionalFields.tumorConference.typ = 'ther'
          break
        case 'therTreatment':
          this.model.reportType = 'behandlungsbeginn'
          this.model.additionalFields.tumorConference.typ = 'ther'
          break
        case 'therState':
          this.model.reportType = 'statusaenderung'
          this.model.additionalFields.tumorConference.typ = 'ther'
          break
        default:
          // default is postth
          this.model.reportType = 'behandlungsende'
          this.model.additionalFields.tumorConference.typ = 'postth'
      }

      if (this.$refs[this.path + '.additionalFields.tumorConference.typ']) {
        this.$nextTick(() => {
          this.$refs[this.path + '.additionalFields.tumorConference.typ'].validate()
        })
      }
    },

    /**
     * Set value of tumorConferenceTypesListItem after loading new or existing form
     *
     * @param type The type of tumor conference e.g. praeth
     * @param reportReason The report reason of form
     * @returns {string}
     */
    setTumorConferenceTypesListItem (type, reportReason) {
      switch (type) {
        case 'praeth':
          if (reportReason === 'diagnose') return 'praethDiagnosis'
          else if (reportReason === 'behandlungsbeginn') return 'praethTreatment'
          else return 'praethState'
        case 'postop':
          return 'postop'
        case 'ther':
          if (reportReason === 'diagnose') return 'therDiagnosis'
          else if (reportReason === 'behandlungsbeginn') return 'therTreatment'
          else return 'therState'
        default:
          // default is postth
          return 'postth'
      }
    },

    /**
     * Add new type of recommendation to array
     */
    addNewRecommendation () {
      this.addItem('additionalFields.tumorConference.therapieempfehlung.typ_therapieempfehlungen', '')
    },

    /**
     * Delete recommendation from recommendation array
     *
     * @param value The array
     * @param index The index of array
     * @param field The validator field
     */
    deleteRecommendation (value, index, field) {
      this.$delete(value, index)
      this.$nextTick(() => {
        this.validationRef.fields[field].changed = true
      })
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', { tumorConference: {} })
          }

          // set value of tumorConferenceTypesListItem, if type and report reason exist or reset value
          this.tumorConferenceTypesListItem = null
          if (this.model.additionalFields.tumorConference.typ && this.model.reportType) {
            this.tumorConferenceTypesListItem = this.setTumorConferenceTypesListItem(this.model.additionalFields.tumorConference.typ, this.model.reportType)
          }
        }
      },
      immediate: true
    }
  }
}
</script>
